module.exports = __webpack_public_path__ + "static/media/CNews4.a37b1201.png";